import React, {useState} from "react";
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';
import FaqItem from '~/components/Dynamic/FaqItem';
import Button from '~/components/Dynamic/Button';

const FAQSection = ({ blok }) => {
  const { textCard, faqItems, bottomCtaHeading, bottomCtaButton } = blok;
  const [expanded, setExpanded] = useState(false);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section>
        <div className="container">
          <div className="mx-auto max-w-45">
            <TextCard blok={textCard[0]} />

            {faqItems.map((blok, i) => (
              <div key={`parent${blok._uid}`}>
                <FaqItem
                expanded={expanded}
                setExpanded={setExpanded} 
                blok={blok}
                idx={blok._uid}
                />
              </div>
            ))}

            {bottomCtaHeading?.length > 0 && (
              <div className="flex justify-center">
                <div className="flex flex-col items-center mt-16">
                  <div className="text-h4 mb-4 font-semibold tracking-tighter leading-[1.01em]">{bottomCtaHeading}</div>
                  {bottomCtaButton?.length > 0 && (
                    <div className="mt-3">
                      <Button blok={bottomCtaButton[0]} />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default FAQSection;
